import dayjs from "dayjs";

export const validateForm = (formData, setErrors) => {
  let errors = {};
  if (!formData.ArtRunner) errors.ArtRunner = "Art Runner is required";
  if (!formData.ArtType) errors.ArtType = "Art Type is required";
  if (!formData.ShowName) errors.ShowName = "Show Name is required";
  if (!formData.ShowDetails) errors.ShowDetails = "Show Details are required";
  if (!formData.VenueName) errors.VenueName = "Venue Name is required";
  if (!formData.VenueAddress) errors.VenueAddress = "Venue Address is required";
  if (!formData.ShowDate) errors.ShowDate = "Show Date is required";
  if (!formData.DoorOpens) errors.DoorOpens = "DoorOpens is required";
  if (!formData.StartTime) errors.StartTime = "Start Time is required";
  if (!formData.EndTime) errors.EndTime = "End Time is required";

  if (formData.StartTime && formData.DoorOpens) {
    const startTime = dayjs(formData.StartTime, "HH:mm");
    const DoorOpensTime = dayjs(formData.DoorOpens, "HH:mm");
    if (DoorOpensTime.isAfter(startTime)) {
      errors.DoorOpens = "Door open time must be before start time";
    }
  }

  if (!formData.isMidNight) {
    if (formData.StartTime && formData.EndTime) {
      const startTime = dayjs(formData.StartTime, "HH:mm");
      const endTime = dayjs(formData.EndTime, "HH:mm");
      if (endTime.isBefore(startTime)) {
        errors.EndTime = "End Time must be greater than Start Time";
      }
    }
  }

  if (!formData.VisibilityType)
    errors.VisibilityType = "VisibilityType is required";

  if (!formData.TicketImages) errors.TicketImages = "TicketImages is required";
  if (!formData.Expect) errors.Expect = "Expect is required";
  if (!formData.Expect1) errors.Expect1 = "Expect is required";
  if (!formData.Expect2) errors.Expect2 = "Expect is required";

  if (formData.EventPoster?.length === 0)
    errors.EventPoster = "EventPoster is required";
  if (!formData.EventEntry) errors.EventEntry = "EventEntry is required";

  if (formData.EventEntry === "Ticket") {
    // Price validations
    if (!formData.VIPPrice && !formData.economyPrice) {
      errors.VIPPrice = "At least one ticket price is required";
      errors.EconomyPrice = "At least one ticket price is required";
    }

    // VIP validation
    if (formData.VIPPrice) {
      if (parseFloat(formData.VIPPrice) <= 0) {
        errors.VIPPrice = "VIP Price must be greater than 0";
      }
      if (formData.VIPSeats && parseFloat(formData.VIPSeats) <= 0) {
        errors.VIPSeats = "VIP Seats must be greater than 0";
      }
    }

    // Economy validation
    if (formData.economyPrice) {
      if (parseFloat(formData.economyPrice) <= 0) {
        errors.EconomyPrice = "Economy Price must be greater than 0";
      }
      if (formData.economySeats && parseFloat(formData.economySeats) <= 0) {
        errors.EconomySeats = "Economy Seats must be greater than 0";
      }
    }

    // Currency validation
    if (!formData.currency) {
      errors.currency = "Currency is required";
    }

    if (!formData.exchangeRate || parseFloat(formData.exchangeRate) <= 0) {
      errors.exchangeRate = "Valid exchange rate is required";
    }

    // Payment provider validation
    if (!formData.paymentProvider) {
      errors.paymentProvider = "Payment provider is required";
    }

    // Ticket page link validation for Third-Party
    if (formData.paymentProvider === "Third-Party") {
      if (!formData.ticketPageLink) {
        errors.ticketPageLink = "Ticket page link is required for third-party payment";
      } else if (!/^https?:\/\/\S+$/.test(formData.ticketPageLink)) {
        errors.ticketPageLink = "Invalid URL format";
      }
    }

    // Stripe validation
    if (formData.paymentProvider === "Stripe") {
      // Stripe requires at least one price to be set
      if (!formData.VIPPrice && !formData.economyPrice) {
        errors.VIPPrice = "At least one price is required for Stripe payments";
      }
    }
  }

  // Free entry validation
  if (formData.EventEntry === "Free") {
    if (!formData.freeSeats) {
      errors.freeSeats = "Free seats are required";
    } else if (parseFloat(formData.freeSeats) <= 0) {
      errors.freeSeats = "Free seats must be greater than 0";
    }
  }

  // Personally Approve validations
  if (formData.PersonallyApprove === true) {
    if (
      formData.ArtRunner === "Open Mic" ||
      formData.ArtRunner === "Showcase"
    ) {
      if (!formData.NumberSpots)
        errors.NumberSpots = "Number Spots is required";
    }

    if (!formData.Requirements)
      errors.Requirements = "Requirements is required";
    if (formData.AlwaysVisible === 3) {
      if (!formData.CustomDate) errors.CustomDate = "CustomDate is required";
      if (!formData.CustomTime) errors.CustomTime = "CustomTime is required";
    }
  }
  if (formData.AutoRepeat === true) {
    if (!formData.RepeatType) errors.RepeatType = "RepeatType is required";
    if (formData.RepeatType === "Custom") {
      if (!formData.DayWeek) errors.DayWeek = "DayWeek is required";
      if (!formData.WeekMonth) errors.WeekMonth = "WeekMonth is required";
    }
  }

  setErrors(errors);
  return Object.keys(errors).length === 0;
};